export interface LayoutConf {
	mobileBreakpoint: number;
	desktopScrollBreakpoint: number;
}

export const layoutConf: LayoutConf = {
	mobileBreakpoint: 850,
	desktopScrollBreakpoint: 90,
};
